<div>
    <h2>{{'global.cultivos' | translate}}</h2>
    <div class="filters-info" *ngIf="filtersVisible">{{'global.infoRequired' | translate}}</div>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}} *</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')"
                    [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-cultivos.filters.denominacion' | translate}} *</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                    [disabled]="disabledDenominaciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-cultivos.filters.campanya' | translate}}</label>
                <app-filterable-list [itemsList]="campanyas" [selectedItem]="filtersForm.get('campanya')"
                    [disabled]="disabledCampanyas" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.finca' | translate}}</label>
                <input type="text" formControlName="desFinca">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-cultivos.filters.productor' | translate}}</label>
                <input type="text" formControlName="desProductor">
            </div>
            <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons">
        <i class="fas fa-file-pdf" [ngClass]="{'disabled': !historicoCultivos}"
            (click)="exportarPdfOrExcel('pdf')" title="{{'titles.exportarPDF' | translate}}"></i>
        <i class="fa-solid fa-circle-question" (click)="openDocHelp()"
            title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="icon"></th>
                        <th class="string sortable" (click)="toOrderBy('$.DesCampanya', 2)">
                            {{'historico-cultivos.table.campanya' | translate}}
                            <div class="sortable-icons"><i [ngClass]="getIcon('$.DesCampanya')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('$.Finca.DesProvincia', 3)">
                            {{'global.provincia' | translate}}
                            <div class="sortable-icons"><i [ngClass]="getIcon('$.Finca.DesProvincia')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('$.Finca.DesMunicipio', 4)">
                            {{'global.municipio' | translate}}
                            <div class="sortable-icons"><i [ngClass]="getIcon('$.Finca.DesMunicipio')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('$.Finca.DesFinca', 5)">
                            {{'global.finca' | translate}}
                            <div class="sortable-icons"><i [ngClass]="getIcon('$.Finca.DesFinca')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('$.Productores[0].DesProductor', 6)">
                            {{'historico-cultivos.table.productor' | translate}}
                            <div class="sortable-icons"><i [ngClass]="getIcon('$.Productores[0].DesProductor')"></i></div>
                        </th>
                        <th class="number">
                            {{'historico-cultivos.table.aforo' | translate}}
                        </th>
                    </tr>
                </thead>
                <tbody class="clickable" *ngFor="let historico of historicoCultivos; let i = index; trackBy: trackByCultivoId">
                    <tr (click)="showDetails(i)" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
                        <td class="icon"><i
                                [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                                title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                        </td>
                        <td class="string">{{historico.anyoCampanya}}</td>
                        <td class="string">{{historico.desProvincia}}</td>
                        <td class="string">{{historico.desMunicipio}}</td>
                        <td class="string">{{historico.desFinca}}</td>
                        <td class="string">{{historico.desProductor}}</td>
                        <td class="number">{{historico.aforo | number : '1.2-2': defaultLanguage}}</td>
                    </tr>
                    <tr *ngIf="dropdownInfo === i">
                        <td colspan="11">
                            <div class="detail">
                                <div class="title">{{'global.masInformacion' | translate}}</div>
                                <div class="block-inline">
                                    <label>{{'historico-cultivos.table.id' | translate}}</label>
                                    <p>{{historico.cultivoId}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-cultivos.table.altura' | translate}}</label>
                                    <p>{{historico.alturaNivelMar}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-cultivos.table.superficie' | translate}}</label>
                                    <p>{{historico.superficie}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-cultivos.table.poligono' | translate}}</label>
                                    <p>{{historico.poligonoCatastral}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-cultivos.table.parcela' | translate}}</label>
                                    <p>{{historico.parcelaCatastral}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-cultivos.table.nPlantas' | translate}}</label>
                                    <p>{{historico.nPlantas | number : '1.0-0': defaultLanguage}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-cultivos.table.licencia' | translate}}</label>
                                    <p>{{historico.nLicencia}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-cultivos.table.fincaDePrueba' | translate}}</label>
                                    <i *ngIf="historico.fincaDePrueba" class="fa-regular fa-circle-check"
                                        title="{{'titles.fincaPrueba' | translate}}"></i>
                                    <i *ngIf="!historico.fincaDePrueba" style="color:red" class="fa-regular fa-circle-xmark"
                                        title="{{'titles.fincaPrueba' | translate}}"></i>
                                </div>
                                <div class="block-inline"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!historicoCultivos || (historicoCultivos && historicoCultivos.length < 1)">
                    <tr>
                        <td colspan="11">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="historicoCultivos && historicoCultivos.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
        (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
    </app-paginator>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes"
        (closed)="showError=$event; showWarning=$event">
    </app-toast>
</div>